import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.header`
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    figure {
        margin-left: 50px;
        img {
            width: 100px;
        }
    }

    ul {
        display: flex;
        align-items: center;
        margin-right: 50px;
        li {
            color: var(--strong-pink);
            margin: 0px 25px 0px 0px;
            font-family: Arial, Helvetica, sans-serif;
            font-weight: 500;
            font-size: 18px;
            transition: 0.3s;
            
            &:hover {
                color: ${lighten(0.03, '#ffa5c1')}
            }

            &:nth-child(5) {
                color: var(--white);
                padding: 10px 15px 10px 15px;
                border: 1px solid transparent;
                background: var(--strong-pink);
                border-radius: 25px;
                transition: 0.3s ease;

                &:hover {
                    border: 1px solid var(--strong-pink);
                    background: var(--white);
                    color: var(--strong-pink);
                }
            }
            a {
                color: var(--strong-pink);
                text-decoration: none;
                transition: 0.3s;

                &:hover {
                    color: ${lighten(0.03, '#ffa5c1')}
                }
            }
        }
    }
`;